<p [class.nearly-expired]="oneMinLeft" [class.warning]="fiveMinsLeft">
  {{ "taker.quizzes.time-left" | translate }}: {{ hours }} hours,
  {{ minutes }} minutes, {{ seconds }} seconds
</p>
